/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { ActivityIndicator } from 'antd-mobile';
import { withRouter } from 'react-router-dom';
import styles from './projectList.module.scss';
import RightArrow from '../../static/images/rightArrow.png';
import NoProjectImg from '../../static/images/noProject.png';
import { ApiCore } from '../../api/index';

const api = new ApiCore();

function ProjectList(props: any) {

    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [noProject, showNoProject] = useState(false);

    useEffect(() => {
        document.title = '项目列表';
        initData();
    }, [])

    /**
     * 初始化数据
     */
    const initData = () => {
        toGetProject().then((res: any) => {
            const _list = res.map((val: object, index: number) => {
                return {
                    loadReady: false,
                    project: val,
                    statistic: {
                        groupNum: 0,
                        groupGoal: 0,
                        finnishNum: 0
                    }
                }
            })
            // 预览显示
            setList(_list);
            let promiseArr = res.map((val: any) => {
                return getProjectStatistic(val.code)
            });
            Promise.all(catchFun(promiseArr)).then(result => {
                const _list = res.map((val: object, index: number) => {
                    return {
                        loadReady: true,
                        project: val,
                        statistic: result[index]
                    }
                })
                setList(_list);
                setLoading(false);
                if (res && res.length == 0) {
                    showNoProject(true);
                }
            })
        })
    }

    /**
     * 请求异常捕获
     * @param promiseArr 
     * @returns PromiseArr
     */

    const catchFun = (promiseArr: any) => {
        return promiseArr.map((promise: any) => promise.catch((err: any) => Promise.resolve({})))
    }

    /**
     * 获取所有项目
     */
    const toGetProject = () => {
        return new Promise((resolve, reject) => {
            api.getProject().then((res: any) => {
                if (res.code == 0) {
                    resolve(res.data || [])
                } else {
                    reject(res);
                }
            });
        })
    }

    /**
     * 获取任务表数据
     * @param 项目code
     */
     const getProjectStatistic = (projectCode: any) => {
        return new Promise((resolve, reject) => {
            return api.getDataCRCStatistic({
                projectCode
            })
            .then((res: any) => {
                if (res.code == 0) {
                    resolve(res.data || [])
                } else {
                    reject(res);
                }
            });
        })
    }

    const onclickGoHome = (val: any) => {
        let token = sessionStorage.getItem('token');
        if (token) {
            // 每次点击更新缓存里的roleCode
            let mToken = JSON.parse(token);
            mToken.roleCode = val.project.roleCode;
            sessionStorage.setItem('token', JSON.stringify(mToken));
            localStorage.setItem('token', JSON.stringify(mToken));
        }
        props.history.push(`/home?projectCode=${val.project.code}&projectName=${encodeURIComponent(val.project.name)}`);
    }

    return (
        <div className={styles.projectList_content}>
            <ActivityIndicator animating={loading} size={"small"} text={'正在加载数据'} toast />
            {
                noProject &&
                <div className={styles.no_project} >
                    <img src={NoProjectImg} alt="" />
                </div>
            }
            {
                list && list.map((val: any, key) => 
                    <div className={styles.card} key={key} onClick={() => { onclickGoHome(val) }}>
                        <div className={styles.card_content}>
                            <div className={styles.title}>
                                <div className={styles.icon}></div>
                                <div className={styles.title_text}>
                                    {val.project.name}
                                </div>
                            </div>
                            <div className={styles.middle}> 
                                <span className={styles.gray14}>剩余待完成数</span> 
                                <span className={`${styles.to_complete_num} ${val.statistic.goalNum === null ? styles.to_complete_num_14 : ''}`}>{val.loadReady ? val.statistic.goalNum === null ? '不限' : (val.statistic.goalNum - val.statistic.finnishNum) : null}</span> 
                            </div>
                            <div className={styles.gray13}>
                                <span>目标数</span>
                                <span>{val.loadReady ? val.statistic.goalNum === null ? '不限' : val.statistic.goalNum : null}</span>
                                <span>完成数</span>
                                <span>{val.loadReady ? val.statistic.finnishNum : null}</span>
                                <span>进行中</span>
                                <span>{val.loadReady ? (val.statistic.groupNum - val.statistic.finnishNum) : null}</span>
                            </div>
                        </div>
                        <div className={styles.card_right}>
                            <img src={RightArrow} alt="" />
                        </div>
                    </div>
                )
            }

        </div>
    );
}

export default withRouter(ProjectList);